import React from 'react'
import NewNav from '../components/NewNav'
import OptionsSlider from '../components/OptionsSlider'
import NoteCard from '../components/NoteCard'
import AdvertiserServices from '../components/AdvertiserServices'
import Footer from '../components/Footer'

export default function Whatsnew() {
  return (
    <div>
        <NewNav/>
        <OptionsSlider/>
        <NoteCard/>
        <AdvertiserServices/>
        <Footer/>
    </div>
  )
}
